<div class="searchable-dropdown">
    <input (click)="selectAll($event)"
           (focus)="this.isListVisible.set(true)"
           [ngModel]="filterValue()"
           [autocomplete]="false"
           (ngModelChange)="onInputChange($event)"
           class="input-M peer"
           id="buyer"
           type="search"
           [disabled]="disabled()"
           placeholder="" />
    @if (isListVisible()) {
        <ul class="list whitespace-nowrap">
            @for (option of buyers(); track option.buyerId) {
                <li class="item" (click)="onOptionSelected(option.buyerId)">
                    {{ option.buyerName }} ({{ option.buyerCode }})
                </li>
            } @empty {
                <li class="item">
                    No Result Found
                </li>
            }
        </ul>
    }
    <label for="buyer" class="floating-c-lbl">Buyer</label>
</div>
